import DriveCharge, { PAGE_TYPE } from '@elem/compCommon/DriveCharge';
import AnimationA from './animationA';
import AnimationB from './animationB';
import AnimationC from './animationC';
import AnimationD from './animationD';
import AnimationE from './animationE';
import AnimationF from './animationF';
import AnimationG from './animationG';
import AnimationH from './animationH';
import AnimationI from './animationI';
import AnimationJ from './animationJ';
import AnimationK from './animationK';
import AnimationL from './animationL';
import ProsThink from './prosThink';
import AnimationM from './animationM';
import FeaturedIn from './featuredIn';
import GotoPage from './gotoPage';
import { SHOW_PROS_THINK } from './Delta2Pc';
import OtherList from '@/components/ProductCommon/OtherList';

export default function indexDynamic({ theme, locale, otherProductData }: any) {
    const AU_SITE = ['au'].includes(locale);
    return (
        <>
            <AnimationA />
            <AnimationB />
            <AnimationC />
            <AnimationD />
            <AnimationE />
            <AnimationF />
            {AU_SITE && (
                <>
                    <AnimationH />
                    <AnimationG />
                </>
            )}
            {!AU_SITE && (
                <>
                    <AnimationG />
                    <AnimationH />
                </>
            )}
            {['us', 'ca', 'br', 'mx'].includes(locale) && (
                <div style={{ paddingTop: 200, background: '#000' }}>
                    <DriveCharge locale={locale} pageType={PAGE_TYPE.DELTA_2} />
                </div>
            )}
            <AnimationI />
            {AU_SITE && <AnimationK />}
            <AnimationJ />
            {/* AU 9.19-9.30 正式开售阶段 */}
            {AU_SITE && <GotoPage />}
            {!AU_SITE && <AnimationK />}
            <AnimationL />
            {SHOW_PROS_THINK.includes(locale) && (
                <>
                    <ProsThink />
                    <FeaturedIn />
                </>
            )}
            <AnimationM />
            <div className="delta2-otherlist">
                <OtherList theme={theme} data={otherProductData} />
            </div>
        </>
    );
}
